import Button from "components/Button"
import Modal from "components/Modal"
import { useState, useCallback, useMemo } from "react"
import { useDropzone,FileWithPath } from "react-dropzone";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form"
import { changeProfileImage  } from "services/patient/settings"
import { updateProfileImage } from "store/slices/userSlice"



const AddProfilePic = ({ show, toggleClose }:any) => {

    const dispatch = useDispatch();
    const [ loading, setLoading ] = useState(false)
    const [ err, setErr ] = useState('')
    
    let formData = useMemo(()=>{
        return new FormData();
    },[]) 

    const { handleSubmit} = useForm()

    const onDrop = useCallback(
        (acceptedFiles:any) => {
          const media = acceptedFiles[0];
          formData.append("upload", media);
        },[formData]
      );
   
    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragAccept,
        isDragReject,
        acceptedFiles,
        open,
      } = useDropzone({
         accept:{
            'image/*': ['.png', '.gif', '.jpeg', '.jpg']
          },
        maxFiles: 1,
         maxSize:5242880,
        noClick: true,
        noKeyboard: true,
        onDrop,
      });

      const uploadedFiles = acceptedFiles.map((file:FileWithPath) => (
        <p key={file.path}>
          selected image : {file.path}
        </p>
      ));

    const onSubmit=(data:any)=>{
    setErr('')
    setLoading(true)

    const config = {
        headers: { "content-type": "multipart/form-data" },
    };

    changeProfileImage(formData,config ).then(
        res => {
            setLoading(false)
            toggleClose()
            dispatch(updateProfileImage(res.data.result.profile_image.image_url))
        }).catch(err => {
        setLoading(false)
        setErr(err.response.data.error)
    })

    }
    
    return(
        <Modal show={show} toggleClose={toggleClose} >
            <div className="p-8" >
                    <h4>Upload your profile image here</h4>

                    {(!!err) && (
                        <div
                        className={`  ${
                            !!err && "bg-secondary bg-opacity-10 text-red "
                        }   w-full text-center p-4 mb-4 rounded-md`}
                        >
                        <p
                            className={` ${
                            !!err && "text-secondary "
                            }   text-xs`}
                        >
                            {err}
                        </p>
                        </div>
                    )}

                    <div className="my-8" >
                        <div {...getRootProps({})} className="h-75 pt-16 transition duration-150 ease-in-out ">
                            <input {...getInputProps()} />
                            {isDragActive ? <p>Drop file here</p> : 
                            <p className="text-center justify-center py-8 text_light_gray_text bg-faded">Drag and drop files to upload or click to select files</p>}
                        </div>
                        <button type="button" onClick={open} className="pt-8 pb-2"> 
                                Open File Dialog
                            </button>
                        <div>{uploadedFiles}</div>
                        <form onSubmit={handleSubmit(onSubmit)} className="my-8" >
                            <Button title="Submit file" loading={loading} />
                        </form>
                    </div>
                </div>
            </Modal>
    )
}

export default AddProfilePic